import { FlexColumnAlignJustifyCenter } from "@/components/Flex";
import br from "@/styles/breakpoints.module.css";
import { themeColors } from "@/utils/themeColors";
import React from "react";
import LogoSlider from "../../../TeacherAITools/components/LogoSlider";
import StudentRelyOnKnowt from "../../LandingMainPage/components/StudentsRelyOnKnowt";
import { ReviewType } from "../../LandingMainPage/constants";
import { LandingHalfSection } from "../../components/styled/Containers";
import styles from "./medias/video-summarizer.module.css";

const DefaultHeader = ({
    title,
    subtitle,
    isForSchools,
}: { title?: string; subtitle?: string; isForSchools?: boolean }) => {
    const headerTitle = title ?? "Trusted by millions across the globe";

    return (
        <FlexColumnAlignJustifyCenter
            className={styles.feedbacksHeader}
            style={{
                textAlign: "center",
                overflow: isForSchools ? "visible" : "hidden",
                width: isForSchools ? "100%" : undefined,
            }}>
            {/* Desktop */}
            <div
                className={br.smDownDisplayNone}
                data-testid="auto-id-5f672c90-fa4d-4772-8c6f-1a15f3266f06">
                <h2
                    className={"heading2"}
                    style={{ marginBottom: "1.6rem" }}
                    data-testid="auto-id-ebe099ca-a1aa-44bd-a9e0-b18a401aa08e">
                    {headerTitle}
                </h2>
                <p
                    className={"bodyXl"}
                    data-testid="auto-id-bf90941a-5da1-4bd8-b344-54ecef4d5e6b">
                    {subtitle ?? "Our community of students and teachers trust Knowt to create and study on."}
                </p>

                {isForSchools && <LogoSlider />}
            </div>
            {/* Mobile */}
            <div
                className={br.smUpDisplayNone}
                data-testid="auto-id-72d61734-0a3d-493b-b33b-815a77bcd21c">
                <p
                    className={"bodyBold1"}
                    data-testid="auto-id-558b97c0-e37f-49e3-af8c-539d5b779c0a">{headerTitle}</p>
                <p
                    className={"body2"}
                    data-testid="auto-id-6121450f-ab51-4382-a6ed-318cbe85bba4">Our community of students and teachers trust Knowt to create and study on.</p>
            </div>
        </FlexColumnAlignJustifyCenter>
    );
};

const UsersFeedbacks = ({
    header,
    type,
    title,
    subtitle,
    isForSchools,
    fullHeight,
    isWithStats,
}: {
    header?: React.ReactNode;
    type: ReviewType;
    title?: string;
    subtitle?: string;
    isForSchools?: boolean;
    fullHeight?: boolean;
    isWithStats?: boolean;
}) => {
    return (
        <LandingHalfSection style={{ maxWidth: isForSchools ? "unset" : "120rem", textAlign: "center" }}>
            <h2
                className="heading2"
                style={{ marginBottom: "1rem" }}
                data-testid="auto-id-6b326885-6a19-4780-84b2-188f65c0c26e">
                {title ?? "Trusted by millions"}
            </h2>
            <p
                className="bodyXl"
                style={{ marginBottom: "2.5rem" }}
                data-testid="auto-id-53cd8a5a-8b15-40b4-bcff-fe705f2ee579">
                {subtitle ?? "Everyone is relying on Knowt, and we never let them down."}
            </p>
            {isForSchools && <LogoSlider />}
            {/* TODO: Need refactor to remove the overwriting of the header */}
            <StudentRelyOnKnowt
                header={header || <DefaultHeader title={title} subtitle={subtitle} isForSchools={isForSchools} />}
                type={type}
                containerStyle={{
                    maxWidth: isForSchools ? "98rem" : "unset",
                    overflow: isForSchools ? "visible" : "hidden",
                    padding: isForSchools ? 0 : "unset",
                }}
                feedbacksListContainerStyle={styles.feedbacksListContainer}
                feedbackCardsStyle={{ backgroundColor: themeColors.neutralWhite }}
                fullHeight={fullHeight}
                isWithStats={isWithStats}
            />
        </LandingHalfSection>
    );
};

export default UsersFeedbacks;
